var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { getOrCreateGlobalContext, useContextWithValidation, } from '@adsk/alloy-react-context';
import { getCurrentToken, getEnv } from '@adsk/acs-sc-web-platform-api';
import LbsSdk from '@adsk/acs-lbs-sdk-js';
import { startCase, toLower, keyBy } from 'lodash';
import { LBS_PAGE_SIZE, LOCATIONS_CONTEXT } from '../consts';
import { listToTree } from '../helpers/treeHelpers';
export var LocationContext = getOrCreateGlobalContext(LOCATIONS_CONTEXT);
// Align environment to work with lbs-sdk
var environment = getEnv();
export var LocationProvider = function (_a) {
    var children = _a.children, projectId = _a.projectId, _b = _a.env, env = _b === void 0 ? environment : _b;
    var _c = __read(useState([]), 2), treeData = _c[0], setTreeData = _c[1];
    var _d = __read(useState({}), 2), treeDataMap = _d[0], setTreeDataMap = _d[1];
    var _e = __read(useState(true), 2), isLoading = _e[0], setIsLoading = _e[1];
    var _f = __read(useState(false), 2), isError = _f[0], setIsError = _f[1];
    var lbs = useMemo(function () {
        return new LbsSdk({
            env: startCase(toLower(env)),
            getAccessToken: function () {
                return getCurrentToken().then(function (_a) {
                    var accessToken = _a.accessToken;
                    return Promise.resolve(accessToken);
                });
            },
        });
    }, [env]);
    var node = useMemo(function () { return lbs.getNode(projectId); }, [projectId, lbs]);
    var fetchTreeNodes = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var results, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    setIsError(false);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, node.getTreeNodesPage(LBS_PAGE_SIZE, 0)];
                case 2:
                    results = (_a.sent()).results;
                    setTreeDataMap(keyBy(results, 'id'));
                    setTreeData(listToTree(results));
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setIsLoading(false);
                    setIsError(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [node]);
    useEffect(function () {
        fetchTreeNodes();
    }, [projectId, env, fetchTreeNodes]);
    var retryLoad = function () {
        fetchTreeNodes();
    };
    var setProjectNodes = function (projectNodes) {
        setTreeDataMap(keyBy(projectNodes, 'id'));
        setTreeData(listToTree(projectNodes));
    };
    return (React.createElement(LocationContext.Provider, { value: {
            treeData: treeData,
            treeDataMap: treeDataMap,
            setTreeData: setProjectNodes,
            isLoading: isLoading,
            isError: isError,
            retryLoad: retryLoad,
        } }, children));
};
LocationProvider.displayName = 'LocationProvider';
export var useLocations = function () {
    return useContextWithValidation(LocationContext, {
        hook: 'useLocations',
        provider: 'LocationProvider',
    });
};
